/**
 * What a HELD click/tap on a hostile does — THE seam `q-charged-attacks-design` rebinds
 * (docs/design/combat.md §Control model, "Explicit target"; AD-817).
 *
 * Owner ruling (2026-10-22, AD-817): until the real charged attack exists, a hold fires
 * the equipped weapon's FIRST weapon ability at the held target — the same ability the
 * bar's slot 1 (key `1`) shows, `loadoutState.weaponAbilities[0]`, which the server
 * derives from the mainhand (`backend/src/gateway/weaponType.ts`). No new combat
 * mechanic, no number moves, the seven-button ceiling is unchanged: the hold is a second
 * way to press a button the player already has.
 *
 * When `q-charged-attacks-design` ships, it adds a `{ kind: 'chargedAttack' }` arm here
 * and returns it; the gesture layer (`tapControls.ts`) and the Game's dispatch call only
 * `holdActionFor`, so nothing else needs to learn about the change.
 */

export type HoldAction =
  /** Cast this ability at the held target (today: weapon ability 1). */
  | { kind: 'weaponAbility'; abilityId: string }
  /** No weapon ability known yet (no loadout, empty kit): the hold is a plain basic attack. */
  | { kind: 'basicAttack' };

export function holdActionFor(
  loadout: { weaponAbilities: readonly string[] } | null | undefined,
): HoldAction {
  const first = loadout?.weaponAbilities[0];
  return first !== undefined && first !== ''
    ? { kind: 'weaponAbility', abilityId: first }
    : { kind: 'basicAttack' };
}
